/*
 * @Author: panweikang
 * @Date: 2025-02-19 15:52:22
 * @LastEditTime: 2025-02-24 16:31:03
 * @Description: 
 */

import React, { Component, useEffect, useState, useMemo } from "react";
import './index.scss'
import { connect } from 'react-redux';
import backPng from '../../images/mine/back.png'
import ixuanzhilogoPng from '../../images/mine/ixuanzhilogo.png'
import reliableLogoPng from '../../images/mine/reliable_logo.png'

const MHead = ({ dispatch, router, isBack = true }) => {
  const backHandle = () => {
    router.navigate(-1);
  }
  return (
    <div className="MHead">
      <div className="left">
        <img src={reliableLogoPng} />
        <img src={ixuanzhilogoPng} />
        <p>|</p>
        <p>仓库选址更靠谱</p>
      </div>
      {
        isBack && <div className="right" onClick={backHandle}>
          <img src={backPng} />
        </div>
      }

    </div>

  );
};


function mapStateToProps(store) {
  return {};
}


export default connect(mapStateToProps)(MHead);
